import {AfterContentInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MapViewStore}                                              from '../../stores/layout/mapview.store';
import {ApPermissions}                                             from 'invoker-transport';
import {combineLatest, Observable, of, Subscription}               from 'rxjs';
import {
  IFieldGridData
}                                                                  from '../../factories/field-grid-data-factory.service';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {CropRotationStore, FieldCropRotationHistory}               from '../../stores/farm/crop.rotation.store';
import {CampaignYearStore}                                         from '../../stores/login/campaignyear.store';
import {FieldStore}                                                from '../../stores/farm/field.store';
import {LanguageStore}                                             from '../../stores/translation/language.store';
import {GetRoundNumericPipe}                                       from '../../ap-utils';
import {SettingsStore}                                             from '../../stores/base-data/settings.store';
import {
  GetPermissionPipe
}                                                                  from '../../ap-permission/pipes/get-permission.pipe';
import {RbStore}                                                   from '../../stores/nutrients/rb.store';
import {
  BasicFertilisationSummariesStore
}                                                                  from '../../stores/taskmanagement/basic.fertilisation.summaries.store';
import {filter, map, skip}                                         from 'rxjs/operators';
import {
  ApDynGridPropertyColumnConfig,
  FilterType,
  PropertyTemplate
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {MapViewMode}                                               from '../../ap-interface';
import {
  ApDynGridEditColumnConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  GetElementService
}                                                                  from '../../ap-utils/service/ap-get-element.service';
import {Create, ObjectFactory, StringFactory, TimeSpan}            from 'ts-tooling';
import {
  GetRoundNumericService
}                                                                  from '../../ap-utils/service/get-round-numeric.service';
import {ApGetCropService}                                          from '../../stores/services/ap-get-crop.service';
import {NFertilizationService}                                     from '../../services/data/n-fertilization.service';
import {
  NFertilizationStore
}                                                                  from '../../stores/n-fertilization/n-fertilization.store';
import {ApNutrientService}                                         from '../../ap-utils/service/ap-nutrient.service';
import {
  FieldNutrientDistributionStore
}                                                                  from '../../stores/nutrients/field-nutrient-distributions.store';
import {
  ApDynGridDetailsGridConfig
}                                                                  from '../../ap-dyngrids/config/details/ap-dyn-grid-details-grid-config';
import {SoilGroupFormatPipe}                                       from '../../ap-utils/pipes/soil-group-format.pipe';
import {ApDateService}                                             from '../../ap-core/services/ap-date-service';
import {TranslationStore}                                          from '../../stores/translation/translation.store';
import {DriverStore}                                               from '../../stores/docu/driver.store';
import {MachineStore}                                              from '../../stores/docu/machine.store';
import {InstrumentStore}                                           from '../../stores/docu/instrument.store';
import {FertilizerService}                                         from '../../services/data/fertilizer.service';
import {FertilizerStore}                                           from '../../stores/base-data/fertilizer.store';
import {
  ApNutrientStatisticService
}                                                                  from '../../nutrient-management/service/ap-nutrient-statistic.service';
import {
  ApDynGridPagerConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {
  ApDynComponentComponent
}                                                                  from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApNFertilizationCommonService
}                                                                  from '../../n-fertilization/services/ap-n-fertilization.common.service';
import {
  ApTooltipContentService
}                                                                  from '../../ap-utils/service/ap-tooltip-content.service';
import {
  ApOperationMode
}                                                                  from '../../ap-interface/enums/ap-operation-mode.enum';
import {
  BaseFertilizationService
}                                                                  from '../../services/data/base-fertilization.service';
import {
  NutrientManagementService
}                                                                  from '../../nutrient-management/service/nutrient-management.service';
import {
  ApElementType
}                                                                  from '../../ap-interface/enums/ap-elements-type.enum';
import IInstrument = Data.DocuContext.Instrument.IInstrument;
import IMachine = Data.DocuContext.Machine.IMachine;
import IDriver = Data.DocuContext.Driver.IDriver;
import IBasicFertilisationSummaries = Data.TaskManagement.IBasicFertilisationSummaries;
import IBasicFertilisationPlanBooks = Data.TaskManagement.IBasicFertilisationPlanBooks;
import INFertilizationPlanBook = Data.TaskManagement.INFertilizationPlanBook;
import IField = Data.FieldManagement.IField;
import IRbStatistic = Data.Nutrients.IRbStatistic;
import IFieldNutrientsDistribution = Data.Nutrients.IFieldNutrientsDistribution;
import IDatasetFieldMap = Data.Sensor.IDatasetFieldMap;

export interface IFarmRecordOverviewData extends IFieldGridData {
  NrSNr: string;
  AlreadyApplied: number;
  EcValue: number | null;
  CropNote: string | null;
  NewestSampleDate: Date;
  SoilGroup: number[];
  DetailsRecords: IFarmRecordOverviewDetailsData[];
}

export interface IFarmRecordOverviewDetailsData {
  ApplicationDate: Date;
  ModuleText: string;
  ECStage?: number;
  Duration?: TimeSpan;
  DurationText?: string;
  Driver: IDriver;
  Machine: IMachine;
  Instrument: IInstrument;
  DetailsText: string;
  Notes: string;
}

@Component({
  selector: 'ap-farm-records-overview',
  template: `
    <ap-dyncomponent [caption]="'global_farm_records'"
                     [canSearch]="true"
                     [headerIcon]="'ap-icon-fields'"
                     [filterTooltip]="'filterTooltip'"
                     [loading$]="recordsLoadingOrSaving$"
                     [columns]="columns$ | async"
                     [items]="items$ | async"
                     [pager]="pager$ | async"
                     [details]="details$ | async"
                     [selectable]="{checkboxOnly: false, mode: 'multiple'}">
    </ap-dyncomponent>
  `,
  styles: []
})
export class ApFarmRecordsOverviewComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  public recordsLoadingOrSaving$ = of(false);
  public items$: Observable<IFieldGridData[]> = of([]);
  public details$: Observable<ApDynGridDetailsGridConfig>;
  public columns$: Observable<ApDynGridColumnConfigBase[]> = of([]);
  public pager$: Observable<ApDynGridPagerConfigBase> = of(new ApDynGridPagerConfig());

  protected readonly ApPermissions = ApPermissions;

  private _onPrint: any;
  private _avgContentColumnWidth = 60;
  private _onSelectionChanged: Subscription;
  private _subscriptions: Array<Subscription> = [];

  constructor(private mapViewStore: MapViewStore,
              private campaignYearStore: CampaignYearStore,
              private cropRotationStore: CropRotationStore,
              private fieldStore: FieldStore,
              private languageStore: LanguageStore,
              private roundNumericPipe: GetRoundNumericPipe,
              private roundNumericService: GetRoundNumericService,
              private settingsStore: SettingsStore,
              private permissionPipe: GetPermissionPipe,
              private rbStore: RbStore,
              private elementService: GetElementService,
              private cropService: ApGetCropService,
              private nFertilizationService: NFertilizationService,
              private nFertilizationStore: NFertilizationStore,
              private basicFertilisationSummariesStore: BasicFertilisationSummariesStore,
              private nutrientService: ApNutrientService,
              private nutrientDistributionStore: FieldNutrientDistributionStore,
              private soilGroupFormatPipe: SoilGroupFormatPipe,
              private dateService: ApDateService,
              private translationStore: TranslationStore,
              private driverStore: DriverStore,
              private machineStore: MachineStore,
              private fertilizerStore: FertilizerStore,
              private fertilizerService: FertilizerService,
              private nutrientStatisticService: ApNutrientStatisticService,
              private instrumentStore: InstrumentStore,
              private nCommonService: ApNFertilizationCommonService,
              private tooltipContentService: ApTooltipContentService,
              private baseFertilizationService: BaseFertilizationService,
              private nutrientManagementService: NutrientManagementService) {
  }

  public ngOnInit(): void {
    this.mapViewStore.hideMapView();
    this.recordsLoadingOrSaving$ = combineLatest([
      this.fieldStore.Listen(s => s.loading),
      this.cropRotationStore.Listen(s => s.loading),
      this.basicFertilisationSummariesStore.Listen(s => s.loading),
      this.nFertilizationStore.Listen(s => s.planBooksLoading),
      this.nutrientDistributionStore.Listen(s => s.loading),
      this.rbStore.Listen(s => s.loading)
    ]).pipe(
      map(loadingItems => loadingItems.some(x => x))
    );
    this.columns$ = this._getBaseGrid();
    this.details$ = this._getDetailsGrid();
  }

  public ngAfterContentInit(): void {
    this._postLoadFieldActions(this.fieldStore.Listen(s => s.data).getValue());
    // TODO: Remove after implementation of https://agriconde.atlassian.net/browse/APV49-3414
    this._subscriptions.push(this.campaignYearStore.Listen(s => s.selectedYear).subscribe(() => {
      this.nFertilizationStore.LoadNFertilizationPlanningSummaries();
    }));
    this._subscriptions.push(this.fieldStore.Listen(s => s.data).pipe(skip(1)).subscribe(fields => {
      if (fields == null) {
        return;
      }
      this._postLoadFieldActions(fields);
      this._loadStoreData();
    }));
    this.items$ = this._getItems();
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(d => d.unsubscribe());
    this._onSelectionChanged?.unsubscribe();
  }

  private _loadStoreData(): void {
    this.basicFertilisationSummariesStore.loadBasicFertilisationSummaries();
    this.nFertilizationStore.LoadNFertilizationPlanningSummaries();
  }

  private _getItems(): Observable<IFarmRecordOverviewData[]> {
    return combineLatest([
      this.fieldStore.Listen(s => s.data),
      this.cropRotationStore.Listen(s => s.history),
      this.rbStore.Listen(s => s.rb),
      this.nutrientDistributionStore.Distributions$,
      this.basicFertilisationSummariesStore.Summaries$,
      this.nFertilizationStore.Bookings$(),
      this.nFertilizationStore.Listen(x => x.logfiles)
    ]).pipe(
      filter(([fields, cropRotation, rb, _, bFS, nPlanBooks, _1]) =>
        fields.length !== 0 &&
        Object.keys(cropRotation).length !== 0 && !!rb && !!bFS && !!nPlanBooks),
      map(([fields, cropRotation, rb, nutrientDistribution, bFS, nPlanBooks, _logFiles]) => {
        return [
          fields, cropRotation, rb, nutrientDistribution,
          bFS,
          bFS.map(x => x?.BasicFertilisationPlanBooks).flat(),
          nPlanBooks, _logFiles
        ] as [IField[], FieldCropRotationHistory, IRbStatistic[], IFieldNutrientsDistribution[], IBasicFertilisationSummaries[], IBasicFertilisationPlanBooks[], INFertilizationPlanBook[], IDatasetFieldMap[]];
      }),
      map(([fields, _1, rb, distributions, bfSummaries, bfPlanBooks, nPlanBooks, logFiles]) =>
        fields.map<IFarmRecordOverviewData>((field) => {
          // TODO: FR: Farm Records loading performance https://agriconde.atlassian.net/browse/APV49-4557
          // TODO: Refactor extract and similar places as well?
          const geom = this.fieldStore.getCurrentFieldGeom(field);
          const adminArea = Create(geom?.AdminArea, 0);
          const area = adminArea > 0 ? adminArea / 10000 : '-';
          const alreadyApplied = this.nFertilizationService.calculateAlreadyAppliedFromContentNPlanBooks(field, nPlanBooks, logFiles, bfPlanBooks);
          const mainCrop = this.cropService.parseMainCrop(field);
          const fieldCrop = mainCrop ? this.cropService.getFieldCrop(field) : null;
          const nutrientDist = distributions.find(d => d && d.FieldGeomId === geom.Id);
          const rbResult = rb.FirstOrDefault(x => x.FieldGeomId === geom?.Id);
          const details: IFarmRecordOverviewDetailsData[] = [];

          bfPlanBooks?.filter(pb => pb.FieldId === field?.Id && pb.BookedAt != null &&
            this.campaignYearStore.isDateInSelectedCampaignYear(pb.ApplicationDate) &&
            ((rbResult?.PlanIds != null && rbResult?.PlanIds.length > 0) ? rbResult?.PlanIds.includes(pb.Id) : true))
            .forEach(planBook => {
              const bfSummary = bfSummaries.find(bfs => bfs.Id === planBook.Summary_Id);
              const duration = this._calculateDuration(planBook.TStart, planBook.TEnd);
              details.Add({
                ApplicationDate: this.dateService.getDateMidnight(bfSummary.User_Appl_Date),
                Duration: duration,
                DurationText: duration.ToString('HH:mm'),
                ModuleText: this.translationStore.FindTranslationForSelectedLanguage('Task_Mgmt_GD'),
                Driver: planBook ? this.driverStore.getDriverById(planBook.ExportDriver) : null,
                Instrument: planBook ? this.instrumentStore.getInstrumentById(planBook.ExportInstrument) : null,
                Machine: planBook ? this.machineStore.getMachineById(planBook.ExportMachine) : null,
                DetailsText: this._getBaseFertilizationDetailsText(bfSummary, planBook),
                Notes: bfSummary.Title
              });
            });

          // N Records
          const nPlanBookAll = nPlanBooks?.FindAll(x => x.FieldId === field?.Id && this.campaignYearStore.isDateInSelectedCampaignYear(x.ApplicationDate));
          if (nPlanBookAll && nPlanBookAll.length > 0) {
            const firstPlanBook = nPlanBookAll[0];
            details.Add({
              ApplicationDate: this.dateService.getDateMidnight(firstPlanBook.ApplicationDate),
              ECStage: firstPlanBook.ECValue,
              ModuleText: this.translationStore.FindTranslationForSelectedLanguage('Task_Mgmt_ND'),
              Driver: firstPlanBook ? this.driverStore.getDriverById(firstPlanBook.ExportDriver) : null,
              Instrument: firstPlanBook ? this.instrumentStore.getInstrumentById(firstPlanBook.ExportInstrument) : null,
              Machine: firstPlanBook ? this.machineStore.getMachineById(firstPlanBook.ExportMachine) : null,
              DetailsText: this._getNFertilizationDetailsText(nPlanBookAll),
              Notes: firstPlanBook.Summary.Title
            });
          }
          return {
            Id: field.Id,
            SourceItem: field,
            NrSNr: this.fieldStore.getFieldNumberAndSubNumber(field),
            Area: area === '-' ? undefined :
              this.roundNumericService.roundAsNumber(area, this.settingsStore.FirstSetting.DigitsAfterDecimalPoint),
            AreaOriginal: area === '-' ? undefined : area.toString(10),
            MainCrop: this.cropService.parseMainCrop(field),
            SecondCrop: this.cropService.parseSecondCrop(field),
            MainCropExpectedYield: this.cropService.parseMainCropExpectedYield(field),
            SecondCropExpectedYield: this.cropService.parseSecondCropExpectedYield(field),
            StrawHarvested: this.cropService.parseStrawHarvested(field),
            AlreadyApplied: alreadyApplied ?? 0,
            SoilGroup: nutrientDist ? ObjectFactory.Copy(nutrientDist).SoilGroups.Sort() : [],
            DetailsRecords: details,
            EcValue: fieldCrop?.EcValue,
            CropNote: fieldCrop?.Note
          } as IFarmRecordOverviewData;
        })
      )
    );
  }

  private _getBaseGrid(): Observable<ApDynGridColumnConfigBase[]> {
    return combineLatest([
      this.languageStore.Listen(s => s.selectedLanguage),
      this.settingsStore.Listen(s => s.data),
      this.permissionPipe.transform(ApPermissions.EDIT_FIELDS)
    ]).pipe(
      filter(([language, settings, _]) => !!language && !!settings[0]),
      map(([language, settings, permission]) => ({
        language,
        setting: settings[0],
        permission
      })),
      map((p) => [
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Number',
          field: 'SourceItem.FieldNumber',
          width: 40,
          hide: true,
          headerFilterable: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          filterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini_Subnumber',
          field: 'SourceItem.FieldSubnumber',
          width: 40,
          hide: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          filterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__NumberAbbr',
          field: 'NrSNr',
          filterable: true,
          hide: new ApDynGridColumnHideConfig({
            mapHide: false,
            selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((m) => m !== MapViewMode.NORMAL)),
          }),
          width: 75,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__FieldName',
          field: 'SourceItem.FieldName',
          filterable: true,
          headerFilterable: true,
          sortIndex: 0,
          sortDesc: false,
          width: 100,
          cssClass: 'left'
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__Area_Unit',
          field: 'Area',
          headerFilterable: true,
          width: 60,
          tooltip: (dataItem) => dataItem['AreaOriginal'],
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          pipes: [{
            pipe: this.roundNumericPipe,
            args: [p.setting.DigitsAfterDecimalPoint]
          }]
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'MainCrop',
          field: 'MainCrop',
          filterable: true,
          headerFilterable: true,
          width: 100
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'MainCropExpectedYield',
          title: 'Global__YieldUnit',
          headerFilterable: true,
          width: 60,
          cssClass: 'right',
          filterType: FilterType.NUMBER,
          pipes: [{
            pipe: this.roundNumericPipe,
            args: [p.setting.DigitsAfterDecimalPoint]
          }]
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'ECStageShort',
          field: 'EcValue',
          filterable: true,
          headerFilterable: true,
          width: 40,
          cssClass: 'right',
          filterType: FilterType.NUMBER
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'CropNote',
          title: 'Global__Fieldcrop_Notes',
          tooltip: (dataItem) => this.tooltipContentService.generateCropNoteTooltip(dataItem['CropNote']),
          width: 120
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'AlreadyApplied',
          title: 'Nutrients__already_applied',
          headerExtraLines: ['Nutrients__kg_N_per_ha'],
          width: 60,
          cssClass: 'right',
          filterType: FilterType.NUMBER,
          template: PropertyTemplate.NUMBER,
          filterable: true,
          tooltip: dataItem => dataItem.AlreadyApplied,
          pipes: [{
            pipe: this.roundNumericPipe,
            args: [0]
          }]
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SoilGroup',
          title: 'Nutrients__Soilgroup',
          width: 60,
          hide: true,
          filterable: true,
          filterType: FilterType.NUMBER_LIST,
          headerFilterable: true,
          pipes: [{
            pipe: this.soilGroupFormatPipe,
            args: [0]
          }]
        }),
        new ApDynGridEditColumnConfig({
            data: (() => {
              const options = [];
              options.Add({
                text: 'Print',
                callback: this._onPrint,
                disabled: true
              });
              return options;
            })(),
            disabled: !p.permission,
          }
        )
      ])
    );
  }

  private _postLoadFieldActions(fields: Data.FieldManagement.IField[]): void {
    if (!fields || fields.length === 0) {
      return;
    }
    this.nutrientDistributionStore.loadFieldNutrientDistributions(this._readFieldGeomsOfCurrentLoadedFields(fields));
  }

  public _readFieldGeomsOfCurrentLoadedFields(fields: IField[]): string[] {
    const tmp = [];
    for (const field of fields) {
      if (!field.FieldGeoms || typeof field.FieldGeoms !== typeof [] || field.FieldGeoms.length < 1) {
        // skip Fields without Geometry
        continue;
      }
      for (const geom of field.FieldGeoms) {
        tmp.push(geom.Id);
      }
    }
    return tmp;
  }

  private _getDetailsGrid(): Observable<ApDynGridDetailsGridConfig> {
    return combineLatest([
      this.languageStore.Listen(s => s.selectedLanguage),
      this.settingsStore.Listen(s => s.data),
    ]).pipe(
      map(([language, settings]) => ({language, setting: settings[0]})),
      filter((p) => !!p.language && !!p.setting),
      map((_) =>
        new ApDynGridDetailsGridConfig({
          field: 'DetailsRecords',
          checkboxDisabled: true,
          hide: (dataItem) => dataItem.DetailsRecords.length === 0,
          columns: [
            new ApDynGridPropertyColumnConfig({
              field: 'ApplicationDate',
              title: 'Nutrients__FertilizationDate',
              width: 80,
              filterable: true,
              sortIndex: 1,
              sortDesc: true,
              format: this.languageStore.CurrentDateFormat
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Docu_Ini__Duration',
              field: 'DurationText',
              width: 60,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__EC',
              field: 'ECStage',
              width: 40,
              headerFilterable: true,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Module',
              field: 'ModuleText',
              headerFilterable: true,
              width: this._avgContentColumnWidth,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              field: 'Machine.NameWithSign',
              title: 'Base__Engine',
              width: 100,
              headerFilterable: true,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              field: 'Instrument.Name',
              title: 'AgriConnect_Ini__Tool',
              width: 100,
              headerFilterable: true,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              field: 'Driver.ShortFullName',
              title: 'Docu_Ini__Workers',
              width: 100,
              headerFilterable: true,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              field: 'DetailsText',
              title: 'Global__Details',
              multiline: true,
              width: 300,
              headerFilterable: true,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Note',
              field: 'Notes',
              cssClass: 'left',
              multiline: true,
              width: 100,
              headerFilterable: true,
              filterable: true
            })
          ]
        })
      )
    );
  }

  private _getBaseFertilizationDetailsText(summary: IBasicFertilisationSummaries, planBook: IBasicFertilisationPlanBooks): string {
    const fertilizer = this.fertilizerStore.getFertilizer(planBook.Product_Id);
    const element = summary.User_Operation_Mode?.Id === ApOperationMode.Const && planBook.Operation_Mode?.Id === ApOperationMode.Const ?
      this.nutrientService.getFertilizerLeadingElement(planBook.Product_Id) :
      planBook.Element?.Id;
    const amount = this.roundNumericService.round(this.nutrientService.convertNutrientToGoods(planBook.Product_Id, element, planBook.Appl_Rate), 0);
    const amountUnitHa = this.fertilizerService.getFertilizerUnit(fertilizer, true);
    const amountUnit = this.fertilizerService.getFertilizerUnit(fertilizer, false);
    const product = this.fertilizerService.getFertilizerProductName(fertilizer);
    const bandIdX0 = this.nutrientStatisticService.getAverageNutrientFromStatistic(0, planBook.Statistic);
    const bandIdX1 = this.nutrientStatisticService.getAverageNutrientFromStatistic(1, planBook.Statistic);
    const bandIdX2 = this.nutrientStatisticService.getAverageNutrientFromStatistic(2, planBook.Statistic);
    const bandIdX3 = this.nutrientStatisticService.getAverageNutrientFromStatistic(3, planBook.Statistic);
    const textPValue = this._getValueWithElementPrefix(bandIdX0, ApElementType.P);
    const textKValue = this._getValueWithElementPrefix(bandIdX1, ApElementType.K);
    const textMgValue = this._getValueWithElementPrefix(bandIdX2, ApElementType.Mg);
    const textCaOValue = this._getValueWithElementPrefix(bandIdX3);
    const nValue = this.baseFertilizationService.calculateNElementByLeadElement(planBook.Product_Id, planBook.Statistic)?.Average ?? '';
    const textNValue = (nValue === 0 || nValue == null) ? '' : `N: ${this.roundNumericService.round(nValue)}`;

    const allTextCombined = `${textPValue} ${textKValue} ${textMgValue} ${textCaOValue} ${textNValue}`;
    const finalAmountElementsText = StringFactory.IsNullOrEmpty(allTextCombined) ? '' : `[${allTextCombined}]`.replaceAll('[ ', '[').replaceAll(' ]', ']').replaceAll('  ', ' ');

    const amountSum = this.roundNumericService.round(this.nutrientManagementService.getCalculateSumFertilizerBySinglePlanBook(planBook));
    return `${amount} ${amountUnitHa} ${product} ${finalAmountElementsText}\n${amountSum} ${amountUnit}`;
  }

  private _getValueWithElementPrefix(bandId: any, elementType?: ApElementType): string {
    if (elementType) {
      // No need to convert to oxide here because values are already in correct form
      const value = this.elementService.CalculateToElementByGivenValue(bandId, elementType, false, true);
      return (value === 0 || value == null) ? '' : `${this.elementService.GetElementStringByString(elementType)}: ${this.roundNumericService.round(value)}`;
    } else {
      return (bandId === 0 || bandId == null) ? ''
        : `${this.translationStore.FindTranslationForSelectedLanguage('Nutrients__CaO')}: ${this.roundNumericService.round(bandId)}`;
    }
  }

  private _getNFertilizationDetailsText(nPlanBooks: INFertilizationPlanBook[]): string {
    const firstPlanBook = nPlanBooks[0];
    const fertilizer = this.fertilizerStore.getFertilizer(firstPlanBook.ProductId);
    const amount = this.roundNumericService.roundAsNumber(this.nFertilizationService.calculateProductAmountFromPlanBooks(nPlanBooks), 0);
    const amountUnit = this.nCommonService.getProductUnit(firstPlanBook);
    const product = this.fertilizerService.getFertilizerProductName(fertilizer);
    const applicationMode = this.nutrientService.getFertilizerStatusDescription(firstPlanBook.ApplicationMode, false);
    return `${amount ?? 0} ${amountUnit} ${product}, ${applicationMode}`;
  }

  private _calculateDuration(TStart: System.ITimeSpan, TEnd: System.ITimeSpan): TimeSpan {
    return TimeSpan.FromMilliseconds((TStart != null && TEnd != null) ? TEnd.TotalMilliseconds - TStart.TotalMilliseconds : 0);
  }
}
